const api = {
  getproject,
  getProjectDetail,
  projectPass,
  projectNoPass,
  projectSoltOut,
  getTypeList,
  getHouseTypeDetail,
  HouseTypePass,
  HouseTypeNoPass,
  HouseTypeSoltOut,
  getBrokers,
  gethouselistvsproduct,
  borkerPass,
  borkerNoPass,
  addOfficial,
  getOfficial,
  editOfficial,
  delOfficial,
  refreshAccessToken,
  pullArticle,
  addNews,
  addArticleForofficial,
  editCity,
  getnewsList,
  setNewAddress,
  addProject,
  getProjectList,
  projectPutaway,
  projectDelete,
  getProjectById,
  editProjectBasics,
  editProjectLightsopt,
  editProjectExpertRemark,
  editProjectInfo,
  editProjectAlbum,
  addProjectType,
  editProjectType,
  getProjectTypeById,
  getProjectTypesList,
  projectTypePutaway,
  delProjectType,
  getExpertRemarkList,
  getProjectAlbumVsId,
  addProjectClient,
  getClientsListForProject,
  getclientsStatistics,
  editProjectDynamic,
  getConsultants,
  consultantPass,
  consultantNoPass,
  addAdminTypes,
  getAdminTypesList,
  forbiddenAdminTypes,
  delAdminTypes,
  editAdminTypesPermission,
  getAdminTypesById,
  getAdminUserList,
  addAdminUser,
  delAdminUser,
  forbiddenAdminUser,
  setAppletHomeBanner,
  getAppletHomeBanner,
  uploadFile,
  uploadfilevsnologo,
  multipleFilesUpload,
  getTags,
  login,
  getCityList,
  addProjectCity,
  updateProjectCity,
  deleteProjectCity,
  getProjectDynamicList,
  addProjectDynamic,
  delProjectDynamic,
  putAwayProjectDynamic,
  getProjectDynamicVsId,
  ProjectDynamicSetProject,
  getProjectUserCommentListVsId,
  putawayProjectUserComment,
  addRobotComment,
  getMemberList,
  getProjectCollectList,
  getallclientswithoutpage,
  getProjectCollectVsId,
  addProjectFollow,
  getTutorList,
  addTutor,
  editTutor,
  getTutorBsId,
  tutorPutaway,
  delTutor,
  getTutorCaseList,
  addTutorCase,
  getTutorCaseLogs,
  getTutorRecommoned,
  editTutorRecommoned,
  getMember,
  addActivity,
  getActivityList,
  getActivityVsId,
  editActivity,
  putAwayActivity,
  deleteActivity,
  getActivityCollectList,
  getActivityApplyList,
  getquestionlist,
  questionPutaway,
  delQuestion,
  answerPutaway,
  delAnswer,
  discussPutaway,
  delDiscuss,
  delArticle,
  addHomeArticle,
  getHomeArticleList,
  getAllArticleBySource,
  getStickProjectList,
  editProjectStick,
  delProjectStick,
  getRobotList,
  addRobot,
  editRobot,
  wuhanfangajaxrequestdianpingList,
  getConsultantTeamList,
  getConsultantList,
  getConsultantBorkerList,
  consultantbrokerpass,
  consultantbrokernopass,
  getConsultantdetailVsuid,
  consultantPutawayVsId,
  teamConsultantPutawayVsId,
  getTeamconsultantDetailVsId,
  setQuestionModelPutaway,
  getQuestionModelPutaway,
  gettutorapplyList,
  gettutorapplyVsId,
  settutorapplystatus,
  getActivityVideosList,
  setActivityVideos,
  getActivityoptimizations,
  setActivityoptimizations,
  addProjectCientVsValid,
  adminactivityaddclient,
  editProjectCollectVsId,
  getsurveylist,
  getsurveyvsid,
  getsurveyreport,
  getwelfarelist,
  getwelfareadminuselist,
  deletewelfareamdinuser,
  editwelfareadminuserinfo,
  addpaper,
  editpaper,
  getpaperlist,
  getpapervsid,
  placesuggestion,
  mapgeocoder,
  addforeclosurehouse,
  foreclosuredelete,
  foreclosureputaway,
  foreclosureupdatebaseinfo,
  getforeclosurelist,
  getforeclosurevsid,
  edithousealbum,
  foreclosurehousedetailupdate,
  getforeclosuredynamic,
  addforeclosuredynamic,
  addforeclosurehousearticle,
  updateforeclosurearticle,
  getforeclosurearticle,
  addTheProsperity,
  selectTheProsperity,
  deleteTheProsperity,
  projectFacilityIconSubmission,
  getprojectFacilityIconSubmission,
  delprojectFacilityIconSubmission,
  addprojectTour,
  getprojectTour,
  delprojectTour,
  putawayprojectTour,
  projectReservationOrderListQuery,
  delprojectReservationOrderListQuery,
  projectReservationOrderViewing,
  officeClassification,
  addOfficeClassifications,
  delOfficeClassifications,
  officeClassificationOnAndOffTheShelf,
  getclassselect,
  proleaseAdd,
  grtproleaseAdd,
  delproleaseAdd,
  putawayprolease,
  addenterpriseServices,
  getenterpriseServices,
  delenterpriseServices,
  putenterpriseServices,
  addmemberBenefits,
  listmemberBenefits,
  delmemberBenefits,
  putuserWelfareStatus,
  getuserWelfareOrder,
  deluserWelfareOrder,
  changecommercialAssets,
  getcommercialAssets,
  changeuserWelfareOrder,
  adduserWelfareOrder
};
// + '?XDEBUG_SESSION_START=10439'
import { get, post, upload } from "./request";

var baseUrl = "/api/";
// var baseUrl = '/test/';

var attractBroker = baseUrl + "AttractBroker/";
var attractHouse = baseUrl + "AttractHouse/";
var attractProject = baseUrl + "AttractProject/";
var projectArticle = baseUrl + "ProjectArticle/";
var projectHouse = baseUrl + "ProjectHouse/";
var projectOfficial = baseUrl + "ProjectOfficial/";
var projectUser = baseUrl + "ProjectUser/";
var AppletMember = baseUrl + "AppletMember/";
var Upload = baseUrl + "Upload/";
var loginUrl = baseUrl + "Login/";
var cityUrl = baseUrl + "ProjectCity/";
var ProjectDynamicurl = baseUrl + "ProjectDynamic/";
var ProjectUserCommenturl = baseUrl + "ProjectUserComment/";
var ProjectCollecturl = baseUrl + "ProjectCollect/";
var ProjectTutorurl = baseUrl + "ProjectTutor/";
var InvestActivityurl = baseUrl + "InvestActivity/";
var questionurl = baseUrl + "ProjectQuestion/";
var ProjectRoboturl = baseUrl + "ProjectRobot/";
var consultanturl = baseUrl + "ProjectConsultant/";
var paperurl = baseUrl + "PaperController/";
var ForeclosureController = baseUrl + "ForeclosureController/";
var GoodNewsStory = baseUrl + "GoodNewsStory/";
var ProjectTour = baseUrl + "ProjectTour/";
var LeaseCate = baseUrl + "LeaseCate/";
var Lease = baseUrl + "Lease/";
var CompanyService = baseUrl + "CompanyService/";
var UserWelfare = baseUrl + "UserWelfare/";
var CompanyAssets = baseUrl + "CompanyAssets/";


//change商办资产
function changecommercialAssets (params) {
  var url = CompanyAssets + "companyAssetsSave";
  return post(url, params);
}
//get商办资产
function getcommercialAssets (params) {
  var url = CompanyAssets + "companyAssetDetail";
  return post(url, params);
}
//del会员券码
function deluserWelfareOrder (params) {
  var url = UserWelfare + "userWelfareOrderDel";
  return post(url, params);
}
//change会员券码
function changeuserWelfareOrder (params) {
  var url = UserWelfare + "userWelfareOrderChange";
  return post(url, params);
}
//add会员券码
function adduserWelfareOrder (params) {
  var url = UserWelfare + "userWelfareOrderAdd";
  return post(url, params);
}
//get会员券码
function getuserWelfareOrder (params) {
  var url = UserWelfare + "userWelfareOrder";
  return post(url, params);
}
//del会员福利
function delmemberBenefits (params) {
  var url = UserWelfare + "userWelfareDel";
  return post(url, params);
}
//putaway会员福利
function putuserWelfareStatus (params) {
  var url = UserWelfare + "userWelfareStatus";
  return post(url, params);
}
//list会员福利
function listmemberBenefits (params) {
  var url = UserWelfare + "userWelfareList";
  return post(url, params);
}
//add会员福利
function addmemberBenefits (params) {
  var url = UserWelfare + "userWelfareAdd";
  return post(url, params);
}
//add企业服务
function addenterpriseServices (params) {
  var url = CompanyService + "companyServiceAdd";
  return post(url, params);
}
//查询企业服务
function getenterpriseServices (params) {
  var url = CompanyService + "companyServiceList";
  return post(url, params);
}
//删除企业服务
function delenterpriseServices (params) {
  var url = CompanyService + "companyServiceDel";
  return post(url, params);
}
//上下架企业服务
function putenterpriseServices (params) {
  var url = CompanyService + "companyServiceStatus";
  return post(url, params);
}
//办公产品上下架
function putawayprolease (params) {
  var url = Lease + "leaseStatus";
  return post(url, params);
}
//办公产品删除
function delproleaseAdd (params) {
  var url = Lease + "leaseDel";
  return post(url, params);
}
//办公产品查询
function grtproleaseAdd (params) {
  var url = Lease + "leaseList";
  return post(url, params);
}
//办公产品添加
function proleaseAdd (params) {
  var url = Lease + "leaseAdd";
  return post(url, params);
}
//查询分类下拉
function getclassselect (params) {
  var url = Lease + "leaseCateList";
  return post(url, params);
}
//上下架办公分类
function officeClassificationOnAndOffTheShelf (params) {
  var url = LeaseCate + "leaseCateStatus";
  return post(url, params);
}
//删除办公分类
function delOfficeClassifications (params) {
  var url = LeaseCate + "leaseCateDel";
  return post(url, params);
}
//添加办公分类
function addOfficeClassifications (params) {
  var url = LeaseCate + "leaseCateAdd";
  return post(url, params);
}
//办公分类
function officeClassification (params) {
  var url = LeaseCate + "leaseCateList";
  return post(url, params);
}
//项目预约订单阅览
function projectReservationOrderViewing (params) {
  var url = ProjectTour + "projectMessUpDown";
  return post(url, params);
}
//项目预约订单列表删除
function delprojectReservationOrderListQuery (params) {
  var url = ProjectTour + "projectMessDel";
  return post(url, params);
}
//项目预约订单列表查询
function projectReservationOrderListQuery (params) {
  var url = ProjectTour + "projectMessList";
  return post(url, params);
}
//项目巡展 putaway
function putawayprojectTour (params) {
  var url = ProjectTour + "projectTourStatus";
  return post(url, params);
}
//项目巡展 del
function delprojectTour (params) {
  var url = ProjectTour + "projectTourDel";
  return post(url, params);
}
//项目巡展 get
function getprojectTour (params) {
  var url = ProjectTour + "projectTourList";
  return post(url, params);
}
//项目巡展 add
function addprojectTour (params) {
  var url = ProjectTour + "projectTourAdd";
  return post(url, params);
}
//项目设施icon删除
function delprojectFacilityIconSubmission (params) {
  var url = ProjectTour + "projectIconDel";
  return post(url, params);
}
//项目设施icon查询
function getprojectFacilityIconSubmission (params) {
  var url = ProjectTour + "projectIconList";
  return post(url, params);
}
//项目设施icon提交
function projectFacilityIconSubmission (params) {
  var url = ProjectTour + "addProjectIcon";
  return post(url, params);
}

//添加喜报
function addTheProsperity (params) {
  var url = GoodNewsStory + "addTheProsperity";
  return post(url, params);
}
//查询
function selectTheProsperity (params) {
  var url = GoodNewsStory + "selectTheProsperity";
  return post(url, params);
}
//删除
function deleteTheProsperity (params) {
  var url = GoodNewsStory + "deleteTheProsperity";
  return post(url, params);
}
function getproject (params) {
  var url = attractProject + "getProject";
  return post(url, params);
}

function login (params) {
  var url = loginUrl + "login";
  return post(url, params);
}

function getProjectDetail (params) {
  var url = attractProject + "getProjectDetail";
  return post(url, params);
}

function projectPass (params) {
  var url = attractProject + "projectPass";
  return post(url, params);
}

function projectNoPass (params) {
  var url = attractProject + "projectNoPass";
  return post(url, params);
}

function projectSoltOut (params) {
  var url = attractProject + "projectSoltOut";
  return post(url, params);
}

function getTypeList (params) {
  var url = attractHouse + "getTypeList";
  return post(url, params);
}

function getHouseTypeDetail (params) {
  var url = attractHouse + "getHouseTypeDetail";
  return post(url, params);
}

function HouseTypePass (params) {
  var url = attractHouse + "HouseTypePass";
  return post(url, params);
}

function HouseTypeNoPass (params) {
  var url = attractHouse + "HouseTypeNoPass";
  return post(url, params);
}

function HouseTypeSoltOut (params) {
  var url = attractHouse + "HouseTypeSoltOut";
  return post(url, params);
}

function getBrokers (params) {
  var url = attractBroker + "getBrokers";
  return post(url, params);
}

function gethouselistvsproduct (params) {
  var url = attractProject + "gethouselistvsproduct";
  return post(url, params);
}

function borkerPass (params) {
  var url = attractBroker + "borkerPass";
  return post(url, params);
}

function borkerNoPass (params) {
  var url = attractBroker + "borkerNoPass";
  return post(url, params);
}

function addOfficial (params) {
  var url = projectOfficial + "addOfficial";
  return post(url, params);
}

function getOfficial (params) {
  var url = projectOfficial + "getOfficial";
  return post(url, params);
}

function editOfficial (params) {
  var url = projectOfficial + "editOfficial";
  return post(url, params);
}

function delOfficial (params) {
  var url = projectOfficial + "delOfficial";
  return post(url, params);
}

function refreshAccessToken (params) {
  var url = projectOfficial + "refreshAccessToken";
  return post(url, params);
}

function pullArticle (params) {
  var url = projectArticle + "pullArticle";
  return post(url, params);
}

function addNews (params) {
  var url = projectArticle + "addNews";
  return post(url, params);
}

function addArticleForofficial (params) {
  var url = projectArticle + "addArticleForofficial";
  return post(url, params);
}

function editCity (params) {
  var url = projectArticle + "editCity";
  return post(url, params);
}

function getnewsList (params) {
  var url = projectArticle + "getnewsList";
  return post(url, params);
}

function setNewAddress (params) {
  var url = projectArticle + "setNewAddress";
  return post(url, params);
}

function addProject (params) {
  var url = projectHouse + "addProject";
  return post(url, params);
}

function getProjectList (params) {
  var url = projectHouse + "getProjectList";
  return post(url, params);
}

function projectPutaway (params) {
  var url = projectHouse + "projectPutaway";
  return post(url, params);
}

function projectDelete (params) {
  var url = projectHouse + "projectDelete";
  return post(url, params);
}

function getProjectById (params) {
  var url = projectHouse + "getProjectById";
  return post(url, params);
}

function editProjectBasics (params) {
  var url = projectHouse + "editProjectBasics";
  return post(url, params);
}

function editProjectLightsopt (params) {
  var url = projectHouse + "editProjectLightsopt";
  return post(url, params);
}

function editProjectExpertRemark (params) {
  var url = projectHouse + "editProjectExpertRemark";
  return post(url, params);
}

function editProjectInfo (params) {
  var url = projectHouse + "editProjectInfo";
  return post(url, params);
}

function editProjectAlbum (params) {
  var url = projectHouse + "editProjectAlbum";
  return post(url, params);
}

function addProjectType (params) {
  var url = projectHouse + "addProjectType";
  return post(url, params);
}

function editProjectType (params) {
  var url = projectHouse + "editProjectType";
  return post(url, params);
}

function getProjectTypeById (params) {
  var url = projectHouse + "getProjectTypeById";
  return post(url, params);
}

function getProjectTypesList (params) {
  var url = projectHouse + "getProjectTypesList";
  return post(url, params);
}

function projectTypePutaway (params) {
  var url = projectHouse + "projectTypePutaway";
  return post(url, params);
}

function delProjectType (params) {
  var url = projectHouse + "delProjectType";
  return post(url, params);
}

function getExpertRemarkList (params) {
  var url = projectHouse + "getExpertRemarkList";
  return post(url, params);
}

function getProjectAlbumVsId (params) {
  var url = projectHouse + "getProjectAlbumVsId";
  return post(url, params);
}

function addProjectClient (params) {
  var url = projectHouse + "addProjectClient";
  return post(url, params);
}

function getClientsListForProject (params) {
  var url = projectHouse + "getClientsListForProject";
  return post(url, params);
}

function getclientsStatistics (params) {
  var url = projectHouse + "getclientsStatistics";
  return post(url, params);
}

function getConsultants (params) {
  var url = projectUser + "getConsultants";
  return post(url, params);
}

function consultantPass (params) {
  var url = projectUser + "consultantPass";
  return post(url, params);
}

function consultantNoPass (params) {
  var url = projectUser + "consultantNoPass";
  return post(url, params);
}

function addAdminTypes (params) {
  var url = AppletMember + "addAdminTypes";
  return post(url, params);
}

function getAdminTypesList (params) {
  var url = AppletMember + "getAdminTypesList";
  return post(url, params);
}

function forbiddenAdminTypes (params) {
  var url = AppletMember + "forbiddenAdminTypes";
  return post(url, params);
}

function delAdminTypes (params) {
  var url = AppletMember + "delAdminTypes";
  return post(url, params);
}

function editAdminTypesPermission (params) {
  var url = AppletMember + "editAdminTypesPermission";
  return post(url, params);
}

function getAdminTypesById (params) {
  var url = AppletMember + "getAdminTypesById";
  return post(url, params);
}

function getAdminUserList (params) {
  var url = AppletMember + "getAdminUserList";
  return post(url, params);
}

function addAdminUser (params) {
  var url = AppletMember + "addAdminUser";
  return post(url, params);
}

function delAdminUser (params) {
  var url = AppletMember + "delAdminUser";
  return post(url, params);
}

function forbiddenAdminUser (params) {
  var url = AppletMember + "forbiddenAdminUser";
  return post(url, params);
}

function setAppletHomeBanner (params) {
  var url = AppletMember + "setAppletHomeBanner";
  return post(url, params);
}

function getAppletHomeBanner (params) {
  var url = AppletMember + "getAppletHomeBanner";
  return post(url, params);
}

function uploadFile (params) {
  var url = Upload + "uploadFile";
  return upload(url, params);
}
function uploadfilevsnologo (params) {
  var url = Upload + "uploadfilevsnologo";
  return upload(url, params);
}
function multipleFilesUpload (params) {
  var url = Upload + "multipleFilesUpload";
  return upload(url, params);
}

function getTags (params) {
  var url = projectHouse + "getTags";
  return post(url, params);
}

function addProjectCity (params) {
  var url = cityUrl + "addProjectCity";
  return post(url, params);
}

function getCityList (params) {
  var url = cityUrl + "getCityList";
  return post(url, params);
}

function updateProjectCity (params) {
  var url = cityUrl + "updateProjectCity";
  return post(url, params);
}

function deleteProjectCity (params) {
  var url = cityUrl + "deleteProjectCity";
  return post(url, params);
}

function getProjectDynamicList (params) {
  var url = ProjectDynamicurl + "getProjectDynamicList";
  return post(url, params);
}

function addProjectDynamic (params) {
  var url = ProjectDynamicurl + "addProjectDynamic";
  return post(url, params);
}

function editProjectDynamic (params) {
  var url = projectHouse + "editProjectDynamic";
  return post(url, params);
}

function delProjectDynamic (params) {
  var url = ProjectDynamicurl + "delProjectDynamic";
  return post(url, params);
}

function putAwayProjectDynamic (params) {
  var url = ProjectDynamicurl + "putAwayProjectDynamic";
  return post(url, params);
}

function getProjectDynamicVsId (params) {
  var url = ProjectDynamicurl + "getProjectDynamicVsId";
  return post(url, params);
}

function ProjectDynamicSetProject (params) {
  var url = ProjectDynamicurl + "ProjectDynamicSetProject";
  return post(url, params);
}

function getProjectUserCommentListVsId (params) {
  var url = ProjectUserCommenturl + "getProjectUserCommentListVsId";
  return post(url, params);
}

function putawayProjectUserComment (params) {
  var url = ProjectUserCommenturl + "putawayProjectUserComment";
  return post(url, params);
}

function addRobotComment (params) {
  var url = ProjectUserCommenturl + "addRobotComment";
  return post(url, params);
}

function getMemberList (params) {
  var url = ProjectCollecturl + "getMemberList";
  return post(url, params);
}

function getProjectCollectList (params) {
  var url = ProjectCollecturl + "getProjectCollectList";
  return post(url + '?XDEBUG_SESSION_START=10439', params);
}

function getallclientswithoutpage (params) {
  var url = ProjectCollecturl + "getallclientswithoutpage";
  return post(url, params);
}

function getProjectCollectVsId (params) {
  var url = ProjectCollecturl + "getProjectCollectVsId";
  return post(url, params);
}

function addProjectFollow (params) {
  var url = ProjectCollecturl + "addProjectFollow";
  return post(url, params);
}

function addProjectCientVsValid (params) {
  var url = ProjectCollecturl + "addProjectCientVsValid";
  return post(url, params);
}

function getTutorList (params) {
  var url = ProjectTutorurl + "getTutorList";
  return post(url, params);
}

function addTutor (params) {
  var url = ProjectTutorurl + "addTutor";
  return post(url, params);
}

function editTutor (params) {
  var url = ProjectTutorurl + "editTutor";
  return post(url, params);
}

function getTutorBsId (params) {
  var url = ProjectTutorurl + "getTutorBsId";
  return post(url, params);
}

function tutorPutaway (params) {
  var url = ProjectTutorurl + "tutorPutaway";
  return post(url, params);
}

function delTutor (params) {
  var url = ProjectTutorurl + "delTutor";
  return post(url, params);
}

function getTutorCaseList (params) {
  var url = ProjectTutorurl + "getTutorCaseList";
  return post(url, params);
}

function addTutorCase (params) {
  var url = ProjectTutorurl + "addTutorCase";
  return post(url, params);
}

function getTutorCaseLogs (params) {
  var url = ProjectTutorurl + "getTutorCaseLogs";
  return post(url, params);
}

function getTutorRecommoned (params) {
  var url = ProjectTutorurl + "getTutorRecommoned";
  return post(url, params);
}

function editTutorRecommoned (params) {
  var url = ProjectTutorurl + "editTutorRecommoned";
  return post(url, params);
}

function getMember (params) {
  var url = ProjectTutorurl + "getMember";
  return post(url, params);
}

function addActivity (params) {
  var url = InvestActivityurl + "addActivity";
  return post(url, params);
}

function getActivityList (params) {
  var url = InvestActivityurl + "getActivityList";
  return post(url, params);
}

function getActivityVsId (params) {
  var url = InvestActivityurl + "getActivityVsId";
  return post(url, params);
}

function editActivity (params) {
  var url = InvestActivityurl + "editActivity";
  return post(url, params);
}

function putAwayActivity (params) {
  var url = InvestActivityurl + "putAwayActivity";
  return post(url, params);
}

function deleteActivity (params) {
  var url = InvestActivityurl + "deleteActivity";
  return post(url, params);
}

function getActivityCollectList (params) {
  var url = InvestActivityurl + "getActivityCollectList";
  return post(url, params);
}

function getActivityApplyList (params) {
  var url = InvestActivityurl + "getActivityApplyList";
  return post(url, params);
}

function getActivityVideosList (params) {
  var url = InvestActivityurl + "getActivityVideosList";
  return post(url, params);
}

function setActivityVideos (params) {
  var url = InvestActivityurl + "setActivityVideos";
  return post(url, params);
}

function getActivityoptimizations (params) {
  var url = InvestActivityurl + "getActivityoptimizations";
  return post(url, params);
}

function setActivityoptimizations (params) {
  var url = InvestActivityurl + "setActivityoptimizations";
  return post(url, params);
}

function getquestionlist (params) {
  var url = questionurl + "getquestionlist";
  return post(url, params);
}

function questionPutaway (params) {
  var url = questionurl + "questionPutaway";
  return post(url, params);
}

function delQuestion (params) {
  var url = questionurl + "delQuestion";
  return post(url, params);
}

function answerPutaway (params) {
  var url = questionurl + "answerPutaway";
  return post(url, params);
}

function delAnswer (params) {
  var url = questionurl + "delAnswer";
  return post(url, params);
}

function discussPutaway (params) {
  var url = questionurl + "discussPutaway";
  return post(url, params);
}

function delDiscuss (params) {
  var url = questionurl + "delDiscuss";
  return post(url, params);
}

function delArticle (params) {
  var url = projectArticle + "delArticle";
  return post(url, params);
}

function addHomeArticle (params) {
  var url = projectArticle + "addHomeArticle";
  return post(url, params);
}

function getHomeArticleList (params) {
  var url = projectArticle + "getHomeArticleList";
  return post(url, params);
}

function getAllArticleBySource (params) {
  var url = projectArticle + "getAllArticleBySource";
  return post(url, params);
}

function getStickProjectList (params) {
  var url = projectHouse + "getStickProjectList";
  return post(url, params);
}

function editProjectStick (params) {
  var url = projectHouse + "editProjectStick";
  return post(url, params);
}

function delProjectStick (params) {
  var url = projectHouse + "delProjectStick";
  return post(url, params);
}

function getRobotList (params) {
  var url = ProjectRoboturl + "getRobotList";
  return post(url, params);
}

function addRobot (params) {
  var url = ProjectRoboturl + "addRobot";
  return post(url, params);
}

function editRobot (params) {
  var url = ProjectRoboturl + "editRobot";
  return post(url, params);
}

function wuhanfangajaxrequestdianpingList (params) {
  var url = "/wuhanfang/house/ajaxrequest/dianpingList_201501.php";
  return post(url, params);
}

function getConsultantTeamList (params) {
  var url = consultanturl + "getConsultantTeamList";
  return post(url, params);
}

function getConsultantList (params) {
  var url = consultanturl + "getConsultantList";
  return post(url, params);
}

function getConsultantBorkerList (params) {
  var url = consultanturl + "getConsultantBorkerList";
  return post(url, params);
}

function consultantbrokerpass (params) {
  var url = consultanturl + "consultantbrokerpass";
  return post(url, params);
}

function consultantbrokernopass (params) {
  var url = consultanturl + "consultantbrokernopass";
  return post(url, params);
}

function getConsultantdetailVsuid (params) {
  var url = consultanturl + "getConsultantdetailVsuid";
  return post(url, params);
}

function consultantPutawayVsId (params) {
  var url = consultanturl + "consultantPutawayVsId";
  return post(url, params);
}

function teamConsultantPutawayVsId (params) {
  var url = consultanturl + "teamConsultantPutawayVsId";
  return post(url, params);
}

function getTeamconsultantDetailVsId (params) {
  var url = consultanturl + "getTeamconsultantDetailVsId";
  return post(url, params);
}

function setQuestionModelPutaway (params) {
  var url = questionurl + "setQuestionModelPutaway";
  return post(url, params);
}

function getQuestionModelPutaway (params) {
  var url = questionurl + "getQuestionModelPutaway";
  return post(url, params);
}

function gettutorapplyList (params) {
  var url = ProjectTutorurl + "gettutorapplyList";
  return post(url, params);
}

function gettutorapplyVsId (params) {
  var url = ProjectTutorurl + "gettutorapplyVsId";
  return post(url, params);
}

function settutorapplystatus (params) {
  var url = ProjectTutorurl + "settutorapplystatus";
  return post(url, params);
}

function adminactivityaddclient (params) {
  var url = InvestActivityurl + "adminactivityaddclient";
  return post(url, params);
}

function editProjectCollectVsId (params) {
  var url = ProjectCollecturl + "editProjectCollectVsId";
  return post(url, params);
}

function getsurveylist (params) {
  var url = InvestActivityurl + "getsurveylist";
  return post(url, params);
}

function getsurveyvsid (params) {
  var url = InvestActivityurl + "getsurveyvsid";
  return post(url, params);
}

function getsurveyreport (params) {
  var url = InvestActivityurl + "getsurveyreport";
  return post(url, params);
}

function getwelfarelist (params) {
  var url = InvestActivityurl + "getwelfarelist";
  return post(url, params);
}

function editwelfareadminuserinfo (params) {
  var url = InvestActivityurl + "editwelfareadminuserinfo";
  return post(url, params);
}

function deletewelfareamdinuser (params) {
  var url = InvestActivityurl + "deletewelfareamdinuser";
  return post(url, params);
}

function getwelfareadminuselist (params) {
  var url = InvestActivityurl + "getwelfareadminuselist";
  return post(url, params);
}

function addpaper (params) {
  var url = paperurl + "addpaper";
  return post(url, params);
}

function editpaper (params) {
  var url = paperurl + "editpaper";
  return post(url, params);
}

function getpaperlist (params) {
  var url = paperurl + "getpaperlist";
  return post(url, params);
}

function getpapervsid (params) {
  var url = paperurl + "getpapervsid";
  return post(url, params);
}

function placesuggestion (params) {
  var url = "/qqmap/ws/place/v1/suggestion/?region=" + params.region + "&keyword=" + params.keyword + "&key=BUGBZ-NR4KP-2AFDK-LJLEB-W2LVV-S5FGH";
  return get(url);
}

function mapgeocoder (params) {
  var url = "/qqmap/ws/geocoder/v1";
  return post(url, params);
}

function addforeclosurehouse (params) {
  var url = ForeclosureController + "addforeclosurehouse";
  return post(url, params);
}

function foreclosuredelete (params) {
  var url = ForeclosureController + "foreclosuredelete";
  return post(url, params);
}
function foreclosureputaway (params) {
  var url = ForeclosureController + "foreclosureputaway";
  return post(url, params);
}

function foreclosureupdatebaseinfo (params) {
  var url = ForeclosureController + "foreclosureupdatebaseinfo";
  return post(url, params);
}
function getforeclosurelist (params) {
  var url = ForeclosureController + "getforeclosurelist";
  return post(url, params);
}

function getforeclosurevsid (params) {
  var url = ForeclosureController + "getforeclosurevsid";
  return post(url, params);
}

function edithousealbum (params) {
  var url = ForeclosureController + "edithousealbum";
  return post(url, params);
}

function foreclosurehousedetailupdate (params) {
  var url = ForeclosureController + "foreclosurehousedetailupdate";
  return post(url, params);
}

function getforeclosuredynamic (params) {
  var url = ForeclosureController + "getforeclosuredynamic";
  return post(url, params);
}

function addforeclosuredynamic (params) {
  var url = ForeclosureController + "addforeclosuredynamic";
  return post(url, params);
}

function addforeclosurehousearticle (params) {
  var url = ForeclosureController + "addforeclosurehousearticle";
  return post(url, params);
}

function updateforeclosurearticle (params) {
  var url = ForeclosureController + "updateforeclosurearticle";
  return post(url, params);
}

function getforeclosurearticle (params) {
  var url = ForeclosureController + "getforeclosurearticle";
  return post(url, params);
}

export default api;
